import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    DatePicker, Input,Select,
} from 'antd';
const FormItem = Form.Item;
const { RangePicker } = DatePicker;
import {formatFormData} from './utils';
import { actions,} from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
        //执行父组件的方法，将this传过去
        this.props.handleSearch(this)
    }

    handleReset= () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        console.log('=====searchValue', values);
        this.props.changeSearchValues(formatFormData(values));
        this.props.resetPagination();
        this.props.asyncGetEvs();// 改造
    }
    addTaskNote = () =>{
        this.props.addShow();
    }
    sendCommend = () => {
        // 下发命令
        this.props.editShow();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        let taskMonitorList1 = new Array();
        
        let i =0;
        const taskMonitorList2 = taskMonitorList1.map(item => {
            return (
                <Option key={i} value={item}>
                    {item}
                </Option>
            );
            i++;
        });
        const dateFormat = 'YYYY-MM-DD';
        
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>素材填充率</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6}>
                            <FormItem {...spans} label="时间段">
                                {getFieldDecorator('dateTime')(
                                    <RangePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        placeholder="选择时间"
                                    />)}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="taskId" {...spans}>
                                {getFieldDecorator('taskId')(
                                    <Input placeholder="请输入整数"/>

                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="eId" {...spans}>
                                {getFieldDecorator('eId')(
                                    <Input placeholder="请输入"/>
                                )}
                            </FormItem>
                        </Col>
                    
                    
                        <Col span={4}>
                            <FormItem label="广告位名称" {...spans}>
                                {getFieldDecorator('taskName')(
                                    <Input placeholder="请输入"/>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="ps" {...spans}>
                                {getFieldDecorator('ps')(
                                    <Input placeholder="请输入"/>
                                )}
                            </FormItem>
                        </Col>
                        </Row>
                        <Row>
                        <Col span={3}>
                            <FormItem label="时间" {...spans}>
                                {getFieldDecorator('time')(
                                    <Select style={{ width: '100px' }} allowClear>
                                        <Option value="1">近两分钟</Option>
                                        <Option value="5">近五分钟</Option>
                                        <Option value="10">近十分钟</Option>
                                        <Option value="30">近半小时</Option>
                                        <Option value="60">近一小时</Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    
    uiStatus: state.localResourceRate.uiStatus,
});

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/monitor/localResourceRate/search.js